import axios from 'axios'
import AuthService from 'services/AuthService'

export default {
    uploadCsv(file, campaignType, pcp) {
        return axios.post(`/admin/claim-profile`, {
            file: file.base64File,
            campaignType,
            pcp,
        })
    },

    inviteToPractice(data) {
        return axios.post(`/users/${data.userId}/join-invites/practice`, data)
    },

    inviteToNetwork(data) {
        return axios.post(`/users/${data.userId}/join-invites/network`, data)
    },

    getLicenseRequests(params) {
        return axios.get('/admin/license-requests', { params })
    },

    getOutreachTasks(params) {
        return axios.get('/admin/outreach-tasks', { params })
    },
    resendOutreachTask(taskId) {
        return axios.post(`/admin/outreach-tasks/${taskId}/resend`)
    },

    approveLicense(userId) {
        return axios.post(`/admin/license-requests/${userId}/approve`)
    },

    rejectLicense(userId) {
        return axios.post(`/admin/license-requests/${userId}/reject`)
    },

    getLicenseFile(fileName) {
        const apiUrl = process.env.VUE_APP_API_URL
        return fetch(`${apiUrl}/admin/license-requests/file/${fileName}`, {
            headers: {
                Authorization: `Bearer ${AuthService.getToken()}`,
            },
        }).then((response) => {
            if (!response.ok) {
                throw new Error(`HTTP error! status: ${response.status}`)
            }
            return response.blob()
        })
    },
}
